<template>
    <client-page>
        <sub-visual-full bg="/images/sub/visual/sv2-2.jpg" video="/images/sub/visual/sv2-2.mp4">
            <div class="text-ani-wrap">
                <div class="text-ani">
                    <h2 class="font-weight-bold">고객사</h2>
                </div>
            </div>
        </sub-visual-full>

        <section class="section">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit font-weight-bold">
                        세계적인 기업 및 단체들이 <br class="d-none d-md-block">
                        세일즈웍스와 함께합니다.
                    </h3>
                </div>
                <div class="mb-50 mb-lg-100">
                    <h5 class="bar-text mb-30 mb-lg-34">
                        국내외 기업
                    </h5>
                    <v-row no-gutters data-aos="fade" data-aos-offset="400" data-aos-delay="100">
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-1.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-2.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-3.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-4.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-5.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-6.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-7.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-8.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                    <v-row no-gutters data-aos="fade" data-aos-offset="400" data-aos-delay="300">
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-9.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-10.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-11.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-12.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-13.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-14.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-15.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-16.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                    <v-row no-gutters data-aos="fade" data-aos-offset="400" data-aos-delay="500">
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-17.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-18.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-19.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-20.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-21.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-22.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-23.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner1-24.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                </div>

                <v-divider class="border-lg-2"></v-divider>

                <div class="mt-50 mt-lg-100">
                    <h5 class="bar-text mb-30 mb-lg-34">
                        비영리단체
                    </h5>
                    <v-row no-gutters data-aos="fade" data-aos-offset="400" data-aos-delay="100">
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-1.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-2.jpg" class="w-100"></v-img>
                        </v-col>
                        <!-- <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-3.jpg" class="w-100"></v-img>
                        </v-col> -->
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-4.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-5.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-6.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-7.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-8.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-9.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                    <v-row no-gutters data-aos="fade" data-aos-offset="400" data-aos-delay="300">
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-10.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-11.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-12.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-13.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-14.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-15.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-16.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-17.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                    <v-row no-gutters data-aos="fade" data-aos-offset="400" data-aos-delay="500">
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-18.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-19.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-20.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-21.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-22.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-23.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-24.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-25.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                    <v-row no-gutters data-aos="fade" data-aos-offset="400" data-aos-delay="700">
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-26.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-27.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-28.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-29.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-30.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-31.jpg" class="w-100"></v-img>
                        </v-col>
                        <v-col cols="6" sm="3">
                            <v-img src="/images/sub/business/client/partner2-32.jpg" class="w-100"></v-img>
                        </v-col>
                    </v-row>
                </div>
            </v-container>
        </section>

    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/templates/ClientPage.vue";
import SubVisualFull from "@/components/client/sub/sub-visual-full.vue";
export default {
    components: {
        ClientPage,
        SubVisualFull,
    },
};
</script>